import { useQuery, useMutation, useQueryClient } from "react-query";
import { getProducts } from "./productAPI";

function useProducts(id) {
  return useQuery("products", () => getProducts(id));
}

export { useProducts };
